<template>
  <div class="order-wrapper" id="print">
    <portal target-el="#filter">
      <Breadcrumb
        back="InvoiceDetails"
        title="INVOICE SUMMARY"
        :invoice="invoice"
        :loading="loaded"
        :checkEditStatus="$invoice.canEditInvoice(invoice.status)"
        v-on:printInvoice="printInvoice"
        v-on:approve="showApprovePopup = true"
        v-on:reject="dialogReject = true"
      />
    </portal>

    <div class="pdfheader webnone">
      <div class="row no-margin">
        <div class="col invoiceleft">
        {{extractFirstPayment.depot.name}}
        </div>
        <div class="col invoiceright">
          <div class="">Invoice No:</div>
          <div class="">{{invoice.invoice_number}}</div>
        </div>
      </div>
    </div>

    <div class="table-title row no-margin table-title-content">
      <div class="col-lg-3 col-md-3 content-section-left no-padding">

        <div class="content-section">
          <div class="content-list">
            <span class="content-list-title bold primary-text">
              {{invoice.transporter.name}}
            </span>
          </div>
          <div class="content-list">
            <span class="content-list-title">
              {{invoice.transporter.address}}
              {{invoice.transporter.city}}
              {{invoice.transporter.state}}
            </span>
          </div>
          <div class="content-list">
            <span class="content-list-title bold">
              GST IN :
            </span>
            <span class="content-list-title">
              {{ invoice.gst_number || '--'}}
            </span>
          </div>
          <div class="content-list" v-if="invoice.transporter.pan_number">
            <span class="content-list-title bold">
              PAN :
            </span>
            <span class="content-list-title">
              {{ invoice.transporter.pan_number || '--'}}
            </span>
          </div>
        </div>
      </div>
      <div class="col-lg-5 col-md-5 content-section-left">
        <div class="content-section">
          <div class="content-list">
            <span class="content-list-title bold primary-text">
              {{extractFirstPayment.depot.name}}
            </span>
          </div>
          <div class="content-list">
            <span class="content-list-title">
              {{extractFirstPayment.depot.address}} ,
              {{extractFirstPayment.depot.city}},
              {{extractFirstPayment.depot.state}}
            </span>
          </div>
          <div class="content-list">
            <span class="content-list-title bold">
              GST IN :
            </span>
            <span class="content-list-title">
              {{extractFirstPayment.depot.gstn_no}}
            </span>
          </div>
          <!-- <div class="content-list">
            <span class="content-list-title bold">
              PAN :
            </span>
            <span class="content-list-title">
              --
            </span>
          </div> -->
        </div>
      </div>
      <div class="col-lg-4 col-md-6 content-section-right no-padding">
        <div class="content-section">
          <div class="content-list">
            <span class="content-list-title">
              {{invoice.created_at | moment("DD MMM YYYY")}}
            </span>
          </div>
          <div class="content-list">
            <span class="content-list-title bold">
              Tax payable on reverese charge :
            </span>
            <span class="content-list-title">
              {{(invoice.gst_type === 2) ? 'YES' : 'No' }}
            </span>
          </div>
          <div class="content-list">
            <span class="content-list-title bold">
              Service Description :
            </span>
            <span class="content-list-title">
              Movement of goods by Road
            </span>
          </div>
          <div class="content-list">
            <span class="content-list-title bold">
              HSN/SAC :
            </span>
            <span class="content-list-title"> -- </span>
          </div>
          <div class="content-list pdfnone">
            <div class="action">
              <Popover popper-class="popover-medium" placement="bottom-end" v-model="comment">
                <div class="popover-primary">
                  <div class="popover-primary-header">
                    <h3>COMMENTS</h3>
                    <span class="remove-icon" @click="comment=false">
                    <svgicon name="cancel" width="10" height="10" :original="true" />
                    </span>
                  </div>
                  <div class="popover-primary-body">
                    <Comments
                      :showForm="commentLoading"
                      :comments="comments"
                      v-on:addComment="addConversation"/>
                  </div>
                </div>
                <div @click="getComments()" slot="reference">
                  <svgicon name="Comments" :original="true" class="svg-icon" width="15" height="15" />
                  COMMENTS
                </div>
              </Popover>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="summary-content">
      <div class="table-title">
        <h2>SUMMARY</h2>
      </div>
      <div class="order-list-wrapper">
        <div class="table">
          <Header />
          <div class="tablerow-scroll" style="max-height:308px;">
            <Row v-for="payment in invoice.order_payments" :key="payment.id" :payment="payment" />
          </div>
        </div>
        <Footer
          v-if="invoice.order_payments"
          :customFields="customFields"
          :extractTax="extractTax"
          :invoice="invoice"
          :indentsTotal="indentsTotal"
          :invoiceTotal ="invoiceTotal"
          :total_state_tax ="total_state_tax"
          :total_central_tax ="total_central_tax"
          :total_igst_tax ="total_igst_tax"
          :noteDetails ="noteDetails"
          v-on:noteDetails="noteDetails"
        />
      </div>
    </div>
    <div class="dialog-window">
      <Dialog :visible.sync="dialogReject" width="25%">
        <div class="dialog-section">
          <div class="el-dialog__title">Return Invoice </div>
          <div class="row-edit">
            <div class="clearfix"></div>
            <div class="row-edit-badge">
              <Return
                v-if="returnFields.length"
                :returnFields="returnFields"
                v-on:return_remarks="return_remarks"
              />
              <div v-else class="col-lg-12 no-padding">
                <label>Add Remarks</label>
                <textarea rows="2" v-model.trim="returnReason"></textarea>
              </div>
            </div>
          </div>
          <div class="submit-button">
            <button class="btn btn-primary" @click="reject">Return</button>
          </div>
        </div>
      </Dialog>
    </div>
    <div class="dialog-window">
      <Dialog :visible.sync="showApprovePopup" width="32%">
        <div class="dialog-section">
          <div class="el-dialog__title">Approve Invoice</div>
          <div class="row-edit">
            <div class="clearfix"></div>
            <div class="row-edit-badge">
              <Approve
                v-on:approve_remarks="approve_remarks"
              />
            </div>
          </div>
          <div class="submit-button">
            <button class="btn btn-primary" :disabled="disableSubmit" @click="approveProcess">
              Submit
            </button>
          </div>
        </div>
      </Dialog>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Comments from '@/components/common/comments';
import Breadcrumb from '../common/breadcrumb';
import Header from './header';
import Row from './row';
import Footer from './footer';
import Return from './return';
import Approve from './approve';
import cssStyle from '@common/styles-shipper/_print';

export default {
  components: {
    Header,
    Row,
    Footer,
    Breadcrumb,
    Comments,
    Return,
    Approve,
  },
  data() {
    return {
      loaded: false,
      dialogReject: false,
      showApprovePopup: false,
      comment: false,
      approveCustomFields: {},
      returnReason: '',
      approveReason: null,
      indentsTotal: 0,
      invoiceTotal: { client: 0, transporter: 0 },
      total_state_tax: 0,
      total_central_tax: 0,
      total_igst_tax: 0,
      noteDetails: {},
      printEnable: '',
      disableSubmit: false,
    };
  },
  computed: {
    ...mapState('invoice', [
      'isLoading',
      'invoice',
      'extractFirstPayment',
      'extractTax',
      'customFields',
      'returnFields',
      'commentLoading',
      'comments',
    ]),
    indentPayments() {
      return this.invoice.order_payments
        .map(indent =>
          indent.charges.map(child =>
            Object.assign({ order_number: indent.order_number }, child),
          ),
        )
        .reduce((l, n) => l.concat(n), []);
    },
  },
  created() {
    this.$store.dispatch('invoice/customFields');
    this.$store.dispatch('invoice/reasonFields');
    if (!this.invoice.id) {
      this.$router.push({ name: 'Invoice' });
    }
    this.baseInvoiceTotal('transporter');
    this.baseInvoiceTotal('client');
  },
  mounted() {
    // this.printEnable = new Printd();
  },
  methods: {
    printInvoice() {
      const prtHtml = document.getElementById('print').innerHTML;
      const WinPrint = window.open(
        '',
        '',
        'top=0,left=0,height=100%,width=auto',
      );
      WinPrint.document.write(`<!DOCTYPE html>
        <html>
        <head>
        <style media="screen">
        body{
          visibility: hidden
        }
        </style>
        <style type="text/css" media="print">
        ${cssStyle}
        </style>
        </head>
        <body>
        ${prtHtml}
        </body>
        </html>`);
      WinPrint.print();
      WinPrint.close();
      WinPrint.document.close();
    },
    async addConversation(comment, type = 1) {
      try {
        const data = { comment, id: this.invoice.id, type, section: 2 };
        const result = await this.$store.dispatch('invoice/addComment', {
          data,
        });
        if (result.error) {
          this.$error({ message: result.error });
        }
      } catch (e) {
        // console.log(e.response);
      }
    },
    async getComments() {
      try {
        const result = await this.$store.dispatch('invoice/comments', {
          data: { id: this.invoice.id, section: 2 },
        });
        if (result.error) {
          this.$error({ message: result.error });
        }
      } catch (e) {
        // console.log(e.response);
      }
    },
    approve_remarks(data) {
      this.approveReason = data;
    },
    customFieldChanges(data) {
      this.approveCustomFields = data;
    },
    return_remarks(data) {
      this.returnReason = data;
    },
    async approveProcess() {
      this.disableSubmit = true;
      try {
        if (this.approveReason) {
          this.addConversation(this.approveReason, 2);
        }
        const result = await this.$store.dispatch('invoice/approve', {
          id: this.invoice.id,
          type: this.noteDetails.noteType,
          amount: this.noteDetails.sumDifference,
          reference_number: this.noteDetails.number,
        });
        if (result.id) {
          this.$success({
            message: `${this.invoice.invoice_number} ${this.$getSuccess(
              'INVOICE_APPROVED',
            )}`,
          });
          this.$router.push({ name: 'Invoice' });
        }
        if (result.error) {
          this.$error({ message: result.error });
        }
      } catch (e) {
        // console.log(e.response);
      }
    },
    async reject() {
      try {
        if (this.returnReason) {
          this.addConversation(this.returnReason, 3);
        }
        const result = await this.$store.dispatch('invoice/reject', {
          id: this.invoice.id,
          reason: this.returnReason,
        });
        if (result.id) {
          this.$success({
            message: `${this.invoice.invoice_number}  ${this.$getSuccess(
              'INVOICE_RETURNED',
            )}`,
          });
          this.$router.push({ name: 'Invoice' });
        }
        if (result.error) {
          this.$error({ message: result.error });
        }
      } catch (e) {
        // console.log(e.response);
      }
    },
    baseInvoiceTotal(section) {
      const total = (this.invoice) ? this.$invoice.invoiceTotal(this.indentPayments, section) : 0;
      this.invoiceTotal[section] = total;
      if (section === 'client') {
        this.indentsTotal = total;
      }
      this.discountCalcualtion(section);
      //  this.walletDetection(section);
      let taxAmount = 0;
      const taxDetails = this.extractTax;
      if (taxDetails.same_state === 1) {
        this.total_central_tax =
          this.invoiceTotal[section] * (taxDetails.cgst / 100);
        this.total_state_tax =
          this.invoiceTotal[section] * (taxDetails.sgst / 100);
        taxAmount = this.total_central_tax + this.total_state_tax;
      } else {
        this.total_igst_tax =
          this.invoiceTotal[section] * (taxDetails.igst / 100);
        taxAmount = this.total_igst_tax;
      }
      if (this.invoice.gst_type === 1) {
        this.invoiceTotal[section] += taxAmount;
      }
      if (section === 'client') {
        this.noteDetails = this.$invoice.checkNote(
          this.invoiceTotal,
          this.invoice.gst_type,
        );
      }
    },

    walletDetection(section) {
      if (this.invoice.wallet_ids && this.invoice.wallet_ids.length) {
        const wallet = this.invoice.wallet_ids.reduce((acc, wal) => acc + wal.amount, 0);
        this.wallet = wallet;
        this.invoiceTotal[section] = this.invoiceTotal[section] - wallet;
      }
    },

    discountCalcualtion(section) {
      return this.invoice.additional_charges.map((discount) => {
        const newObj = {};
        const amount = this.invoiceTotal[section] * (discount.percentage / 100);
        if (discount.method === 1) {
          this.invoiceTotal[section] += amount;
        }
        if (discount.method === 2) {
          this.invoiceTotal[section] -= amount;
        }
        newObj.amount = amount;
        return Object.assign(discount, newObj);
      });
    },
  },
};
</script>
<style lang='scss'>
$fontSemibold: 'OpenSans-Semibold';
$fontBold: 'OpenSans-Bold';

// .payment-actions {
//     width: calc(100% - 1230px);
//     text-align: right;
// }
.order-content {
padding-bottom: 30px;
background: #fff;
//padding: 20px;
box-shadow: 0 2px 4px 0 #ececec;
height: 100vh;
  .table-row {
    padding-left: 15px;
  }
}
.table-title {
  &-content {
      background: #F9FAFA;
      padding: 0;
      border: 1px solid #EFEFEF;
  }
  .float-right {
      text-align: right;
  }
  h2 {
      font-family:$fontSemibold;
      font-size: 1.6rem;
      letter-spacing: 1.33px;
      padding: 0 0 15px;
      margin: 0;
  }
}
.content-section {
  &-left {
    float: left;
    display: inline-block;
    border-left: 0.5px solid #cecece;
    padding: 0 16px;
    margin: 10px 0;
    &:first-child {
      border-left: 0.5px solid transparent;
    }
  }
  &-right {
    float: right;
    display: inline-block;
    text-align: right;
    background: #fff;
    padding: 10px 15px;
  }
}
.content-list {
  line-height: 22px;
  .primary-text {
      font-size: 1.4rem;
  }
  .bold {
      font-family:$fontSemibold;
  }
  &-title {
      font-size: 1.2rem;
      color: #404040;
  }
  .action {
      cursor: pointer;
      color: #376F99;
      font-family:$fontSemibold;
      font-size: 1.2rem;
  }
}
.invoice-right-action {
  width: calc(100% - 550px);
  text-align: right;
  padding-right: 25px !important;
}
.popover-primary {
  textarea {
    border: 1px solid #dee5e6;
    width: 100%;
    border-radius: 2px;
    padding: 10px;
    margin: 20px 0;
    outline: none;
  }
}
.right-btn {
  float: right;
}
</style>
